import { apiClients } from '../config/apiClient';

export const authService = {
  async login(email, password) {
    const response = await apiClients.auth.post('/login', { 
      email, 
      password 
    });
    return response.data;
  },

  async register(email, password, full_name) {
    const response = await apiClients.auth.post('/register', { 
      email, 
      password, 
      full_name 
    });
    return response.data;
  },

  async getCurrentUser() {
    const response = await apiClients.auth.get('/me');
    return response.data;
  },

  async changePassword(current_password, new_password) {
    const response = await apiClients.auth.post('/change-password', {
      current_password,
      new_password
    });
    return response.data;
  },

  async updateProfile(full_name) {
    const response = await apiClients.auth.put('/profile', {
      full_name
    });
    return response.data;
  },

  async requestPasswordReset(email) {
    const response = await apiClients.auth.post('/password-reset-request', { email });
    return response.data;
  },

  async resetPassword(token, new_password) {
    const response = await apiClients.auth.post('/password-reset', { 
      token, 
      new_password 
    });
    return response.data;
  }
};

export default apiClients.auth;
